import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
var initForm = {
  fromDate: '',
  toDate: '',
  placePlatform: ''
};
export default {
  meta: {
    title: '交易分析',
    auth: true,
    authorityValue: 'store-statistics-management'
  },
  name: 'transaction',
  data: function data() {
    return {
      data: {},
      form: cloneDeep(initForm),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      chartData: {
        columns: ['日期', '访问用户'],
        rows: [{
          日期: '2018-01-01',
          访问用户: 1393
        }, {
          日期: '2018-01-02',
          访问用户: 3530
        }, {
          日期: '2018-01-03',
          访问用户: 2923
        }]
      },
      newsList: [{
        tit: '访客数',
        key: 'visitors'
      }, {
        tit: '浏览量',
        key: 'browses'
      }, {
        tit: '人均浏览量',
        key: 'avgBrowses'
      }, {
        hide: true
      }, {
        hide: true
      }, {
        tit: '下单客户数',
        key: 'orderConsumers'
      }, {
        tit: '下单单量',
        key: 'orders'
      }, {
        tit: '下单金额',
        key: 'orderAmount'
      }, {
        tit: '下单商品件数',
        key: 'orderGoods'
      }, {
        hide: true
      }, {
        tit: '成交客户数',
        key: 'tradeConsumers'
      }, {
        tit: '成交单量',
        key: 'trades'
      }, {
        tit: '成交金额',
        key: 'tradeAmount'
      }, {
        tit: '成交商品件数',
        key: 'tradeGoods'
      }, {
        tit: '客单价',
        key: 'avgTradeAmount'
      }],
      checkedCities: ['orderAmount', 'orderGoods', 'trades', 'tradeConsumers']
    };
  },
  computed: {
    orderPlatform: function orderPlatform() {
      var item = {
        label: '全部渠道',
        value: ''
      };
      return [item].concat(_toConsumableArray(this.dict.orderPlatform));
    },
    checkedCitiesLen: function checkedCitiesLen() {
      return this.checkedCities.length;
    }
  },
  watch: {
    checkedCities: {
      handler: function handler(e) {
        this.dataTradeTrends(this.form);
      },
      deep: true
    }
  },
  methods: {
    rangeDateChange: function rangeDateChange(e) {
      if (e === null) {
        this.form.fromDate = '';
        this.form.toDate = '';
      } else {
        this.form.fromDate = e[0];
        this.form.toDate = e[1];
      }

      this.dataBind(this.form);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.dataTrade(item);

              case 2:
                data = _context.sent;
                _this.data = data;

                _this.newsList.forEach(function (v) {
                  return _this.$set(v, 'count', data[v.key] || 0);
                });

                _this.dataTradeTrends(item);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataTradeTrends: function dataTradeTrends(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.dataTradeTrends(item);

              case 2:
                data = _context2.sent;
                _this2.chartData.columns = ['序号'];
                _this2.chartData.rows = _this2.setObj(data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    setObj: function setObj(obj) {
      var _this3 = this;

      var isTrue = function isTrue(type) {
        return _this3.checkedCities.some(function (key) {
          return type == key;
        });
      };

      var columnsParams = [{
        label: '下单单量',
        key: 'orders'
      }, {
        label: '下单客户数',
        key: 'orderConsumers'
      }, {
        label: '下单金额',
        key: 'orderAmount'
      }, {
        label: '下单商品件数',
        key: 'orderGoods'
      }, {
        label: '下单转化率',
        key: 'orderCoverRate'
      }, {
        label: '成交单量',
        key: 'trades'
      }, {
        label: '成交客户数',
        key: 'tradeConsumers'
      }, {
        label: '成交金额',
        key: 'tradeAmount'
      }, {
        label: '成交商品件数',
        key: 'tradeGoods'
      }, {
        label: '客单价',
        key: 'avgTradeAmount'
      }, {
        label: '成交转化率',
        key: 'tradeCoverRate'
      }, {
        label: '下单成交转化率',
        key: 'orderTradeCoverRate'
      }];
      var data = obj.map(function (v, i) {
        if (columnsParams[i]) {
          isTrue(columnsParams[i].key) && _this3.chartData.columns.push(columnsParams[i].label);
        }

        var obj = {
          序号: v.label
        };
        columnsParams.forEach(function (k) {
          return obj[k.label] = v[k.key];
        });
        return obj;
      });
      return cloneDeep(data);
    }
  },
  mounted: function mounted() {
    this.dataBind();
  }
};